import {Box, Text} from '@primer/react'

export type HeaderIssueTypeProps = {
  name: string
}

export function HeaderIssueType({name}: HeaderIssueTypeProps) {
  return (
    <Box
      data-testid="header-issue-type"
      sx={{
        height: '32px',
        px: 3,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '32px',
        backgroundColor: 'canvas.inset',
        borderColor: 'border.muted',
        borderWidth: '1px',
        borderStyle: 'solid',
      }}
    >
      <Text sx={{color: 'fg.muted', fontWeight: 600, whiteSpace: 'nowrap'}}>{name}</Text>
    </Box>
  )
}

try{ HeaderIssueType.displayName ||= 'HeaderIssueType' } catch {}